var mentions_default = {
  "mention": "M9BuG",
  "mentionViewer": "RlcVr",
  "cursorDefault": "P8VAv",
  "cursorPointer": "DmtEm"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
